export default __webpack_public_path__ + "static/media/waiting.2aa74919.png";